import React from "react";

import { DropDownList } from "@progress/kendo-react-dropdowns";

export default function dropdownSkladFilterCell() {
    return class extends React.Component {
        itemRender = (li, itemProps) => {
            const index = itemProps.index;
            const itemChildren = (
                <span>
                    {itemProps.dataItem.nazov}
                </span>
            );

            return React.cloneElement(li, li.props, itemChildren);
        };

        valueRender = (element, value) => {
            if (!value) {
                return element;
            }

            const children = [
                <span key={1}>
                    {value.nazov}
                </span>
            ];

            return React.cloneElement(element, { ...element.props }, children);
        };

        render() {
            var sklady = sessionStorage.getItem("sklady");
            if (!sklady){
                return <React.Fragment />;
            }
            sklady = JSON.parse(sklady);
            var value = "";
            if (this.props.value){
                value = sklady.find((item) => item.id == this.props.value);
            }
            return (
                <div className="k-filtercell">
                    <DropDownList
                        dataItemKey="id"
                        data={sklady}
                        onChange={this.onChange}
                        value={value}
                        defaultItem="Vyberte sklad..."
                        itemRender={this.itemRender}
                        valueRender={this.valueRender}
                    />
                    <button
                        className="k-button k-button-icon k-clear-button-visible"
                        title="Clear"
                        disabled={!this.hasValue(this.props.value)}
                        onClick={this.onClearButtonClick}>
                        <span className="k-icon k-i-filter-clear" />
                    </button>
                </div>
            );
        }

        hasValue = (value) => Boolean(value);

        onChange = (event) => {
            const hasValue = this.hasValue(event.target.value);
            this.props.onChange({
                value: hasValue ? event.target.value.id : "",
                operator: hasValue ? "eq" : "",
                syntheticEvent: event.syntheticEvent
            });
        };

        onClearButtonClick = (event) => {
            event.preventDefault();
            this.props.onChange({
                value: "",
                operator: "",
                syntheticEvent: event
            });
        };
    };
}



// WEBPACK FOOTER //
// ./src/components/common/grid/dropdownSkladFilterCell.js